import ApiService from '@/services/core/api.service'

const AssignEnabledEdit = {
  async put (payload) {
    return ApiService.put(`marketing-officer/assign-enabled-edit?user_id=${payload.user_id}`, payload)
  }
}

export default AssignEnabledEdit
